import { NgClass, NgFor, NgIf, isPlatformBrowser } from '@angular/common';
import { AfterContentChecked, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { AbstractControlOptions, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { MemberService } from 'src/app/api/api/member.service';
import { AppComponent } from 'src/app/app.component';
import { User } from 'src/app/models/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConsoleLoggerService } from 'src/app/services/console-logger.service';
import { CustomValidationService } from 'src/app/services/custom-validation.service';
import { CommonComponent } from '../../common/common.component';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  standalone: true,
  imports: [NgIf, FormsModule, ReactiveFormsModule, NgClass, NgFor, RouterLink, RouterLink]
})
export class PopupComponent extends CommonComponent implements OnInit, AfterContentChecked {
  signInForm: UntypedFormGroup;
  signUpForm: UntypedFormGroup;
  lostPasswordForm: UntypedFormGroup;
  optionChangeForm: UntypedFormGroup;
  submitted = false;
  error = '';
  onlyPhoneNumber = true;
  passwordsMatch = false;
  loading = false;

  submitFormNow = false;

  passwordType = 'password';
  passwordConfirmType = 'password';
  isPassword = true;
  isPasswordConfirm = true;

  @Input() modalIsOpen: boolean;
  @Input() reviewFormIsValid: boolean;
  @Input() isReviewPage = false;
  @Output() closePopupEvent = new EventEmitter<boolean>();
  @Output() submitFormEvt = new EventEmitter<boolean>();
  @Input() reviewFormUserData: {};


  @Input() formValue: string;
  dashboardError: boolean;

  // public formValue = '';
  handleRegistration(): void {
    this.formValue = 'registrati';
  }
  handleAccess(): void {
    this.formValue = 'accedi';
  }

  handleForgottenPassword(): void {
    this.formValue = 'recuperaPassword';
  }

  get log(): {} {
    return this.signInForm.controls;
  }

  get sign(): {} {
    return this.signUpForm.controls;
  }

  get recPassword(): {} {
    return this.lostPasswordForm.controls;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private memberService: MemberService,
    public authenticationService: AuthenticationService,
    private elementRef: ElementRef,
    private customValidator: CustomValidationService,
    public main: AppComponent,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private console: ConsoleLoggerService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    super(authenticationService);
    this.signInForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')])],
      password: ['', Validators.required],
    });
    this.signUpForm = this.formBuilder.group(
      {
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        email: [
          '',
          Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
        ],
        phone_number: [
          '',
          Validators.compose([Validators.minLength(8)])
        ],
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required],
        city: [''],
        state: [''],
        birthday: [''],
        sex: ['uomo'],
        consent_newsletter: [false],
        consent_communications: [false],
        accepts_terms_and_conditions: [false, Validators.requiredTrue],
      },
      {
        validator: this.customValidator.passwordMatchValidator(
          'password',
          'confirmPassword'
        ),
      } as AbstractControlOptions
    );
    this.lostPasswordForm = this.formBuilder.group({
      email: [
        '',
        Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      ],
    });
    this.optionChangeForm = this.formBuilder.group({
      selectedOption: 'immobiliare'
    });
  }

  ngOnInit(): void {
    if (this.isReviewPage === false) {
      this.formValue = 'accedi';
    }
    this.isPassword = true;
    this.passwordType = 'password';
    this.isPasswordConfirm = true;
    this.passwordType = 'password';
  }

  ngAfterContentChecked(): void {
    if (
      this.signUpForm?.controls?.state?.value === '' || this.signUpForm?.controls?.state?.value === ' ') {
      this.signUpForm.controls.city.disable();
    } else {
      this.signUpForm.controls.city.enable();
    }
  }

  // LOGIN
  async signInSubmit(): Promise<void> {
    this.submitted = false;
    this.error = '';
    this.loading = true;

    const controls = this.signInForm.controls;
    if (this.signInForm.invalid) {
      Object.keys(controls).forEach((controlName) =>
        controls[controlName].markAsTouched()
      );
      // alert('form sbagliato')
      return;
    }

    try {
      const values = this.signInForm.value;
      const credential = { email: values.email, password: values.password };
      // const response = await this.memberService.memberLogin(credential).toPromise()
      await lastValueFrom(this.authenticationService
        .login(values.email, values.password, true));
      this.main.getUserData();

      this.main.modalUserOpen = false;
      this.error = '';
      this.submitted = true;
      // azzero campi input dopo login
      this.signInForm.reset();
      this.loading = false;
      this.modalIsOpen = false;

      this.submitFormNow = true;
      this.submitFormEvt.emit(this.submitFormNow);
      if (!this.isReviewPage) {
        // Reload della pagina per riempire i form
        window.location.reload();
      }

      this.toastr.success(
        'Login effettuato correttamente',
        `Hai eseguito l'accesso`
      );

    } catch (e) {
      if (e.message === 'dashboard') {
        this.submitted = true;
        // this.toastr.error(
        //   'Non è possibile loggarsi con questa utenza, vai su dashboard.cercacasa.it',
        //   'Utenza backoffice'
        // );
        this.loading = false;
        this.dashboardError = true;
      } else {
        this.submitted = true;
        this.console.error(e.message);
        this.error = 'La password e la mail inseriti non coincidono.';
        this.loading = false;
      }
      // alert(e)
    }
  }

  // REGISTRAZIONE
  async signUpSubmit(): Promise<void> {
    this.loading = true;
    if (this.signUpForm.status === 'VALID') {
      const member: User = {
        first_name: this.signUpForm.value.first_name,
        last_name: this.signUpForm.value.last_name,
        email: this.signUpForm.value.email,
        password: this.signUpForm.value.password,
        phone_number: this.signUpForm.value.phone_number,
        sex: this.signUpForm.value.sex,
        consent_newsletter: this.signUpForm.value.consent_newsletter,
        consent_communications: this.signUpForm.value.consent_communications,
        accepts_terms_and_conditions: this.signUpForm.value.accepts_terms_and_conditions,
        role: 'user',
      };

      if (this.signUpForm.value.birthday) {
        member.birthday = this.signUpForm.value.birthday;
      }

      if (this.signUpForm.value.city) {
        member.city = this.signUpForm.value.city;
      }

      if (this.signUpForm.value.state) {
        member.state = this.signUpForm.value.state;
      }

      try {

        const response = await this.authenticationService.signup(member);
        this.main.modalUserOpen = false;
        this.loading = false;
        // azzero campi input dopo login
        this.signUpForm.reset();
        this.closePopupEvent.emit();

        this.submitFormNow = true;
        if (!this.isReviewPage) {
          this.submitFormEvt.emit(this.submitFormNow);
        }

      } catch (e) {
        this.toastr.error(
          `L'indirizzo email è già stato utilizzato`,
          'Si è verificato un errore'
        );
        this.console.error(e);
        this.loading = false;
      }
    }
  }

  // RECUPERA PASSWORD  resertpassword su member service
  async lostPasswordSubmit(): Promise<void> {
    this.loading = true;
    const values = this.lostPasswordForm.value;
    try {
      const response = await lastValueFrom(this.memberService.memberResetPassword(JSON.stringify({ email: values.email })));
      this.loading = false;
      this.lostPasswordForm.reset();
      this.modalIsOpen = false;
      this.toastr.success(
        `Riceverai tra pochi minuti una email a ${values.email} con un link per procedere con il reset.`,
        'Email di reset password inviata'
      );

    } catch (e) {
      this.console.error(e);
      this.loading = false;
      if (e === 'Not Found') {
        this.toastr.error(
          'Verifica di aver inserito correttamente l\'indirizzo email con cui ti sei registrato',
          'Indirizzo email non trovato'
        );
      }
    }
  }

  // CONTINUE WITHOUT REGISTRATION
  handleWithoutRegistration(): void {
    this.submitFormNow = true;
    this.submitFormEvt.emit(this.submitFormNow);
  }

  /* close dropdown user menu from outside */
  // @HostListener('window:click', ['$event.target'])
  // public onClick(target): void {
  //   const clickedInside = this.elementRef.nativeElement.contains(target);
  // }

  // open popup form
  closeModal(): void {
    if (this.isReviewPage === false) {
      this.formValue = 'accedi';
      this.isPassword = true;
      this.passwordType = 'password';
      this.isPasswordConfirm = true;
      this.passwordType = 'password';

    } else {
      this.formValue = '';
    }
    this.isPassword = true;
    this.passwordType = 'password';
    this.isPasswordConfirm = true;
    this.passwordType = 'password';
    this.closePopupEvent.emit();
  }

  // Only number allowed into phone input
  onlyNumberAllowed(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      this.onlyPhoneNumber = false;
      return false;
    }
    this.onlyPhoneNumber = true;
    return true;
  }

  changePasswordType(): void {
    this.isPassword = !this.isPassword;
    if (!this.isPassword) {
      this.passwordType = 'text';
    } else {
      this.passwordType = 'password';
    }
  }

  changePasswordConfirmType(): void {
    this.isPasswordConfirm = !this.isPasswordConfirm;
    if (!this.isPasswordConfirm) {
      this.passwordConfirmType = 'text';
    } else {
      this.passwordConfirmType = 'password';
    }
  }

  getCityList(): [] {
    if (
      this.signUpForm?.controls?.state?.value === '' || this.signUpForm?.controls?.state?.value === ' ') {
      return [];
    } else {
      return this.main.provinceComuni.find(a => a.name === this.signUpForm?.controls?.state?.value)?.municipalities || [];
    }
  }

  // SE L'UTENTE CLICCA FUORI DAL POPUP VIENE CHIUSO
  @HostListener('window:click', ['$event.target']) onClick(target): void {
    if (isPlatformBrowser(this.platformId)) {
      if (target.classList.contains('bg-modal')) {
        this.closeModal();
      }
    }
  }

}
